module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_8017.da0d5511.png";